/**
 * Games with a tutorial video in public/games/videos/ (<id>.mp4 + .webm + .jpg),
 * with its length and chapters (seconds) for the tutorial player's scrubber.
 *
 * GENERATED by scripts/record-game-video.mjs — do not edit by hand. A game
 * listed here plays its video on the shelf while its tile is live and gets a
 * "Watch tutorial" button; every other game keeps its cover frames
 * (lib/gameCovers.ts).
 */
export type GameVideo = { duration: number; chapters: { t: number; label: string }[] };

export const GAME_VIDEOS: Record<string, GameVideo> = {
  mandate: {"duration":48,"chapters":[{"t":0,"label":"Choose your leader"},{"t":9,"label":"Your city"},{"t":12,"label":"Develop"},{"t":18,"label":"End month"},{"t":24,"label":"Recruit"},{"t":30,"label":"March"},{"t":36,"label":"Battle"},{"t":45,"label":"Visual guide"}]},
  contra: {"duration":57.5,"chapters":[{"t":0,"label":"Title"},{"t":2.27,"label":"Mission"},{"t":9.3,"label":"Shop"},{"t":17.27,"label":"Fight"},{"t":30.8,"label":"Corridor"},{"t":35.4,"label":"Boss"},{"t":47.9,"label":"Reward"},{"t":54.83,"label":"War Room"}]},
  tanks: {"duration":59.87,"chapters":[{"t":0,"label":"Title"},{"t":2.93,"label":"The Long Wall"},{"t":5.63,"label":"Briefing"},{"t":8.93,"label":"Hold the Core"},{"t":13.83,"label":"The Brickyard"},{"t":22.5,"label":"Hold the Core"},{"t":31.37,"label":"The Foundry Colossus"},{"t":55.4,"label":"Course laid"}]},
};
